if($('#component-application-sharing').length){
    var app = new Vue({
        el: '#component-application-sharing',
        data: {
            data: {},
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationType: applicationType,
            applicationId: applicationId,
            shareId: null,
            sharePassword: null,
            loading: true
        },
        methods: {
            generateShare(){
                this.loading = true;
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/share/'+this.applicationId+'/generate').then((response) =>  {
                    this.getShare();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            regenerateSharing(){
                if(confirm("Regenerating the sharing link will permanently remove the old link and provide you with a new one. Do you wish to proceed?")){
                    this.generateShare();
                }
            },
            copyToClipboard(){
                var copyText = document.getElementById("share-link");
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                document.execCommand("copy");
                copyText.blur();

                this.$toasted.success('Link copied to clipboard');
            },
            shareLink(){
                return location.protocol+'//'+location.hostname+'/organisation/'+this.networkGroupSlug+'/'+this.networkSlug+'/'+this.applicationType+'-application/'+this.applicationId+'/share/'+this.shareId;
            },
            getShare(){
                this.loading = true;
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/share/'+this.applicationId+'/get').then((response) =>  {
                    this.shareId = response.data.share_id;
                    this.sharePassword = response.data.share_password;

                    this.$nextTick(function () {
                        this.loading = false;
                        $(".tooltipped").tooltip();
                    });
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            disableShare(){
                if(confirm("Disabling sharing will mean the current sharing link is permanently deleted. If you re-enable sharing a new link will be created. Do you wish to proceed?")){
                    axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/share/'+this.applicationId+'/disable').then((response) =>  {
                        this.getShare();
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        mounted () {
            this.getShare();
        }
    });
}